import { useAtomValue } from 'jotai';

import { backendStatusAtom } from '@/apis/call';
import { areSearchPreviewsPaused } from '@/util/redisRecovery';

/** True while search previews must not run or be armed. */
export function useSearchPreviewsPaused(): boolean {
  const backendStatus = useAtomValue(backendStatusAtom);
  return areSearchPreviewsPaused({
    backendStatus: backendStatus.status,
  });
}
